









import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class HollowCard extends Vue {
    @Prop({ default: 0 }) count!: number;
    @Prop({ default: '' }) title!: string;
    @Prop({ default: '' }) color!: string;
    @Prop({ default: false }) active!: boolean;
    @Prop({ default: false }) disabled!: boolean;

    get cardBgColor (): string {
      if (!this.active) return 'white'
      return this.hexToRgba(this.color, 0.08)
    }

    get countBgColor (): string {
      return this.active ? this.color : this.hexToRgba(this.color, 0.12)
    }

    get countColor (): string {
      return this.active ? 'white' : this.color
    }

    get titleColor (): string {
      return this.active ? '#1a202c' : '#4a5568'
    }

    hexToRgba (hex: string, alpha: number): string {
      const r = parseInt(hex.slice(1, 3), 16)
      const g = parseInt(hex.slice(3, 5), 16)
      const b = parseInt(hex.slice(5, 7), 16)
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
}
